const filterRegionSpecificPrices = {
  US: {
    air: {
      base: 399,
      del: null,
    },
    airMini: {
      base: 229,
      del: null,
    },
    milaFilter: {
      base: 69,
      del: null,
    },
    milaSocks: {
      base: 60,
      del: null,
    },
  },
  CA: {
    air: {
      base: 470,
      del: null,
    },
    airMini: {
      base: 270,
      del: null,
    },
    milaFilter: {
      base: 80,
      del: null,
    },
    milaSocks: {
      base: 65,
      del: null,
    },
  },
  GB: {
    air: {
      base: 199,
      del: null,
    },
    airMini: {
      base: 199,
      del: 268,
    },
    milaFilter: {
      base: 49,
      del: null,
    },
    milaSocks: {
      base: 45,
      del: null,
    },
  },
  AU: {
    air: {
      base: 199,
      del: null,
    },
    airMini: {
      base: 199,
      del: 268,
    },
    milaFilter: {
      base: 49,
      del: null,
    },
    milaSocks: {
      base: 45,
      del: null,
    },
  },
};

export default filterRegionSpecificPrices;
